module.exports = __webpack_public_path__ + "img/sphere05-graph.a36e5998.png";